import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IpService {
  constructor(private http: HttpClient) {}

  getPublicIp() {
    return this.http
      .get<{ ip: string }>('https://api.ipify.org?format=json')
      .pipe(map((res) => res.ip));
  }
}
